<template>
  <vs-popup
    class="taste-panel-create-popup"
    id="popup"
    title="Taste Panel"
    @close="open = false"
    :active.sync="open"
    :buttons-hidden="true"
  >
    <vx-card no-shadow>
      <div class="p-4">
        <!-- <div class="flex justify-end items-center mb-4 pb-3 border-b">
          <div class="flex gap-2">
            <vs-button
              color="primary"
              type="filled"
              size="large"
              class="w-full font-bold mt-2"
              @click="startTastePanel('Started')"
              v-if="
                tastePanelStatus == 'Pending' || tastePanelStatus == 'Paused'
              "
            >
              Start Taste Panel
            </vs-button>
            <vs-button
              color="danger"
              type="filled"
              size="large"
              class="w-full font-bold mt-2"
              @click="startTastePanel('Paused')"
              v-if="tastePanelStatus == 'Started'"
            >
              Pause Taste Panel
            </vs-button>
            <vs-button
              color="warning"
              type="filled"
              size="large"
              class="w-full font-bold mt-2"
              @click="startTastePanel('Completed')"
              v-if="tastePanelStatus == 'Started'"
            >
              Complete Taste Panel
            </vs-button>
            <vs-button
              color="primary"
              type="filled"
              size="large"
              disabled
              v-if="tastePanelStatus == 'Completed'"
            >
              Completed
            </vs-button>
          </div>
        </div> -->

        <form-wizard
          color="rgba(var(--vs-primary), 1)"
          nextButtonText="Next"
          backButtonText="Previous"
          finishButtonText="Submit & Close"
          title=""
          subtitle=""
          :key="wizardKey"
          @on-complete="submitAllForms"
        >
          <tab-content
            v-for="(form, index) in forms"
            :key="index"
            :title="`${form.code}`"
            :before-change="() => nextStep(form, index)"
          >
            <div class="grid grid-cols-1 md:grid-cols-1 gap-4 mb-4">
              <div class="mb-3">
                <h5 class="font-semibold">
                  {{ form.code }}
                </h5>

                <p class="mt-1 text-gray-600">
                  <span class="font-semibold">Product :</span>
                  {{ form.product_name }}
                </p>
                <p class="mt-1" v-if="forms[index].is_tp_signed_off">
                  <span class="font-semibold text-warning text-sm"
                    >Taste panel is signed off</span
                  >
                </p>
              </div>
              <vx-card no-shadow :card-border="true" class="mb-4">
                <div class="flex items-center mb-4">
                  <h6 class="font-semibold text-base">
                    Last Tested Batch
                  </h6>

                  <span
                    v-if="form.last_tested_batch_result === null || form.last_tested_batch_result.code === 'Lab Standard'"
                    class=" font-semibold"
                  >
                    : Lab Standard
                  </span>
                </div>

                <div v-if="form.last_tested_batch_result !== null" class="flex flex-wrap">
                  <div class="w-full md:w-1/5 px-2 mb-3">
                    <p class="text-xs text-grey mb-1">Batch Code</p>
                    <p class="font-semibold text-sm">{{ form.last_tested_batch_result.code }}</p>
                  </div>

                  <div class="w-full md:w-1/5 px-2 mb-3">
                    <p class="text-xs text-grey mb-1">Signed At</p>
                    <p class="font-semibold text-sm">{{ __dateTimeFormatter(form.last_tested_batch_result.signed_off_at) }}</p>
                  </div>

                  <div class="w-full md:w-1/5 px-2 mb-3">
                    <p class="text-xs text-grey mb-1">Signed By</p>
                    <p class="font-semibold text-sm">{{ form.last_tested_batch_result.signed_off_by }}</p>
                  </div>

                  <div class="w-full md:w-1/5 px-2 mb-3">
                    <p class="text-xs text-grey mb-1">Taste Panel</p>
                    <p class="font-semibold text-sm">{{ form.last_tested_batch_result.group_code }}</p>
                  </div>

                  <div class="w-full md:w-1/5 px-2 mb-3">
                    <p class="text-xs text-grey mb-1">Status</p>
                    <p>
                      {{ form.last_tested_batch_result.signed_off_status }}
                    </p>
                  </div>
                </div>
              </vx-card>
              <vx-card no-shadow :card-border="true">
                <h6 class="font-semibold text-base mb-3 pb-2 border-b">
                  Properties
                </h6>

                <div
                  v-for="(prop, key) in forms[index].properties"
                  :key="key"
                  class="mb-3 last:mb-0"
                >
                  <label class="text-sm font-semibold block mb-2">
                    {{ prop.name
                    }}<span class="text-warning">{{ prop.guide ? ` (Guide: ${prop.guide})` : "" }}</span>
                  </label>

                  <div class="grid grid-cols-3 gap-2">
                    <div class="col-span-2">
                      <ValidationProvider
                        :vid="`comment_${key}`"
                        :name="`${prop.name} Comment`"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <vs-input
                          v-model="forms[index].properties[key].comment"
                          class="w-full"
                          placeholder="Enter comment"
                          :disabled="forms[index].is_tp_signed_off"
                        />
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>

                    <div>
                      <ValidationProvider
                        :vid="`status_${key}`"
                        :name="`${prop.name} Status`"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-select
                          :options="propertyTypeOptions"
                          label="label"
                          :reduce="(o) => o.value"
                          v-model="forms[index].properties[key].status"
                          :clearable="false"
                          placeholder="Select status"
                          :disabled="forms[index].is_tp_signed_off"
                        />
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
              </vx-card>

              <!-- <vx-card no-shadow :card-border="true">
                <h6 class="font-semibold text-base mb-3 pb-2 border-b">
                  Optional Properties
                </h6>

                <div class="space-y-3">
                  <div
                    v-for="(prop, key) in [
                      'specific_gravity',
                      'refractive_index',
                      'moisture',
                      'target',
                    ]"
                    :key="prop"
                  >
                    <label class="text-sm font-semibold block mb-1">
                      {{ forms[index].optional_properties[key].name }}
                    </label>
                    <vs-input
                      v-model="forms[index].optional_properties[key].response"
                      class="w-full"
                      placeholder="Enter value"
                    />
                  </div>
                </div>
              </vx-card> -->
            </div>

            <div class="grid grid-cols-1 md:grid-cols-1 gap-4 mb-4">
              <vx-card no-shadow :card-border="true">
                <label class="text-sm font-semibold block mb-2">Notes</label>
                <vs-textarea
                  v-model="forms[index].notes"
                  class="w-full"
                  placeholder="Add any additional notes here..."
                  rows="3"
                  :disabled="forms[index].is_tp_signed_off"
                />
              </vx-card>

              <!-- <vx-card no-shadow :card-border="true">
                <label class="font-semibold text-base mb-3 pb-2 border-b">
                  Overall Status
                </label>
                <ValidationProvider
                  vid="overallStatus"
                  name="overallStatus"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    :options="overAllStatusOptions"
                    label="label"
                    v-model="forms[index].status"
                    :reduce="(o) => o.value"
                    :clearable="false"
                    class="w-full"
                  />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </vx-card> -->
            </div>

            <!-- <vx-card no-shadow :card-border="true">
              <h6 class="font-semibold text-base mb-3 pb-2 border-b">
                Attachments
              </h6>

              <FilePreviewGallery
                :files="forms[index].file_paths"
                @remove="removeFile"
                class="mb-3"
              />

              <multi-file-uploader
                v-on:onSetFileName="onSetFiles($event, index)"
                :file="''"
                file_path="taste-panel/attachments"
                :condition="true"
              />
            </vx-card> -->
          </tab-content>
        </form-wizard>
      </div>
    </vx-card>
    <show-batch-wo-tp-result ref="showBatchWoTpResult" />
  </vs-popup>
</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import profile from "@/apis/profile.js";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import FilePreviewGallery from "@/components/shared/FilePreviewGallery.vue";
import ErrorMessages from "@/mixins/ErrorMessages";
import ShowBatchWoTpResult from "./ShowBatchWoTpResult.vue";
import { guid } from "@fullcalendar/core/internal";

const TriangleTestsRepository = RepositoryFactory.get("triangle_tests");
const SupplierRawMaterialRepository = RepositoryFactory.get(
  "supplierRawMaterial"
);

function initialState() {
  return {
    open: false,
    steps: [],
    propertyTypeOptions: [
      { label: "Acceptable", value: "Acceptable" },
      { label: "Marginal", value: "Marginal" },
      { label: "Reject", value: "Reject" },
    ],

    tasteGroup: null,
    forms: [],
    current_user: null,
    testVeriable: "",
    updateMode: false,
    overAllStatusOptions: [
      { label: "Pending", value: "Pending" },
      { label: "Passed", value: "Passed" },
      { label: "Failed", value: "Failed" },
    ],
    tastePanelStatus: "",
    wizardKey: 0,
  };
}

export default {
  components: {
    "v-select": vSelect,
    FormWizard,
    TabContent,
    FilePreviewGallery,
    ShowBatchWoTpResult,
  },

  data() {
    return initialState();
  },

  mixins: [ErrorMessages],

  computed: {
    isFormDisabled() {
      return (
        this.tastePanelStatus == "Pending" ||
        this.tastePanelStatus == "Paused" ||
        this.tastePanelStatus == "Completed"
      );
    },
  },

  methods: {
    async openPopup(id) {
      await Object.assign(this.$data, initialState());
      this.tastePanelId = id;

      await this.getTastingGroupDetails();
      await this.getCurrentUser();
      await this.getTastePanelFormsList();
      this.wizardKey++;
      this.open = true;
    },

    async refresh() {
      await this.getTastingGroupDetails();
    },

    async getTastingGroupDetails() {
      try {
        this.$vs.loading();
        const response = await TriangleTestsRepository.getTastingGroup(
          this.tastePanelId
        );
        this.tasteGroup = response.data.data;
        await this.fetchRmCompanyData(
          this.tasteGroup.raw_material_stock_inventories
        );
        // this.tastePanelStatus = this.tasteGroup.staff[0].pivot.status;
      } catch (error) {
      } finally {
        this.$vs.loading.close();
      }
    },
    async getCurrentUser() {
      try {
        const { data } = (await profile.getCurrentUser()).data;
        this.current_user = data;
      } catch (error) {}
    },

    async startTastePanel(status) {
      try {
        this.$vs.loading();
        await TriangleTestsRepository.updateTastingGroupStatus(
          this.tastePanelId,
          {
            staff_id: this.current_user.id,
            status: status,
          }
        );
        await this.refresh();
      } catch (error) {
      } finally {
        this.$vs.loading.close();
      }
    },
    async getTastePanelFormsList() {
      try {
        this.$vs.loading();
        const response =
          await TriangleTestsRepository.getListOfQualityControlTestings(
            `filter[group_id]=${this.tastePanelId}&filter[done_by_id]=${this.current_user.id}`
          );
        this.formList = response.data.data;

        this.initializeForms();
      } catch (error) {
      } finally {
        this.$vs.loading.close();
      }
    },

    async fetchRmCompanyData(rmStockInventories) {
      try {
        this.$vs.loading();

        await Promise.all(
          rmStockInventories.map(async (inventory, index) => {
            const rawMaterialId =
              inventory.staff_raw_material_order_item.raw_material.id;

            const response =
              await SupplierRawMaterialRepository.getRawMaterialCompanyData(
                rawMaterialId
              );

            this.tasteGroup.raw_material_stock_inventories[index].company_data =
              response.data.data;
          })
        );
      } catch (e) {
      } finally {
        this.$vs.loading.close();
      }
    },

    getTpSignedOffStatus(sample) {
      const signOffs = sample.quality_control_batch_sign_off;

      if (!signOffs.length) {
        return false;
      }
      const latest = signOffs[signOffs.length - 1];
      return !(
        latest.status === "Failed & Retest" &&
        sample.pivot.group_id !== latest.group_id
      );
    },

    openLastBatchResult(batch){
    this.$refs.showBatchWoTpResult.openPopup(batch.id, batch.pivot.groupable_type);
    },
    
    getInventoryDetails() {
      this.$vs.loading();
    },

    initializeForms() {
      const sampleArray = this.tasteGroup.work_orders.concat(
        this.tasteGroup.raw_material_stock_inventories
      );
      sampleArray.sort((a, b) => Number(a.pivot.order) - Number(b.pivot.order)).forEach((sample, index) => {
        this.forms.push({
          id: sample.id,
          status: "",
          is_tp_signed_off: this.getTpSignedOffStatus(sample),
          company_data: sample.company_data ? sample.company_data : {},
          pivot:sample.pivot ? sample.pivot : null,
          order:sample.pivot ? sample.pivot.order : null,
          last_tested_batch_result: sample.last_tested_batch_result ? sample.last_tested_batch_result : null,
          code:
            this.getBatchType(sample.pivot.groupable_type) == "Work Order"
              ? sample.work_order_code
              : sample.code,
          product_name:
            this.getBatchType(sample.pivot.groupable_type) == "Work Order"
              ? `${sample.formulation.formulation_code || ""} - ${
                  sample.formulation.name || ""
                }`
              : `${
                  sample.staff_raw_material_order_item.raw_material
                    .company_product_code || ""
                } - ${
                  sample.staff_raw_material_order_item.raw_material
                    .company_product_name || ""
                }`,
          type: this.getBatchType(sample.pivot.groupable_type),
          properties: this.setProperties(sample),
          optional_properties: [
            { name: "Specific Gravity", response: "" },
            { name: "Refractive Index", response: "" },
            { name: "Moisture", response: "" },
            { name: "Target", response: "" },
          ],
          notes: "",
          file_paths: [],
        });
      });
      this.steps = Object.keys(this.forms).map((i) => Number(i));
      if (this.formList.length > 0) {
        this.formList.forEach((saved) => {
          const matchIndex = this.forms.findIndex((f) => {
            return (
              f.id == saved.batch_id &&
              f.type == this.getBatchType(saved.batch_type)
            );
          });
          if (matchIndex !== -1) {
            this.forms[matchIndex].form_id = saved.id;
            this.forms[matchIndex].status = saved.status;
            this.forms[matchIndex].updated = true;
            this.forms[matchIndex].properties = saved.properties;
            this.forms[matchIndex].optional_properties =
              saved.optional_properties;
            this.forms[matchIndex].notes = saved.notes;
            this.forms[matchIndex].file_paths = saved.file_paths;
          }
        });
      }
    },

    setProperties(sample) {
      if (
        this.getBatchType(sample.pivot.groupable_type) == "Work Order" ||
        sample.company_data.test_type === ""
      ) {
        const guide = sample.formulation.q_c_guide
        return [
          { name: "Appearance", comment: "", status: "", guide: guide !== null ? `${guide.appearance_from} - ${guide.appearance_to}` : '' },
          { name: "Odour", comment: "", status: "", guide: guide !== null ? guide.odour : '' },
          { name: "Taste", comment: "", status: "", guide: guide !== null ? guide.taste : '' },
        ];
      } else {
        if (
          sample.company_data.test_type === "Taste_Odour_and_Appearance_Check"
        ) {
          return [
            {
              name: "Appearance",
              comment: "",
              status: "",
              guide: sample.company_data.appearance,
            },
            {
              name: "Odour",
              comment: "",
              status: "",
              guide: sample.company_data.odour,
            },
            {
              name: "Taste",
              comment: "",
              status: "",
              guide: sample.company_data.taste,
            },
          ];
        }
        if (
          sample.company_data.test_type === "Odour_Appearance_SG_and_RI_Check"
        ) {
          return [
            {
              name: "Appearance",
              comment: "",
              status: "",
              guide: sample.company_data.appearance,
            },
            {
              name: "Odour",
              comment: "",
              status: "",
              guide: sample.company_data.odour,
            },
            {
              name: "SG",
              comment: "",
              status: "",
              guide: `${sample.company_data.sg_from} - ${sample.company_data.sg_to}`,
            },
            {
              name: "RI",
              comment: "",
              status: "",
              guide: `${sample.company_data.ri_from} - ${sample.company_data.ri_to}`,
            },
          ];
        }
        if (sample.company_data.test_type === "Odour_and_Appearance_Check") {
          return [
            {
              name: "Appearance",
              comment: "",
              status: "",
              guide: sample.company_data.appearance,
            },
            {
              name: "Odour",
              comment: "",
              status: "",
              guide: sample.company_data.odour,
            },
          ];
        }
      }
    },
    removeFile(index) {
      this.form.file_paths.splice(index, 1);
    },

    onSetFiles(file_path, index) {
      this.forms[index].file_paths.push(file_path);
    },

    validateProperties(properties) {
      for (const property of properties) {
        if (!property.comment || !property.status) {
          this.$vs.dialog({
            color: "danger",
            title: "Warning",
            text: "Please fill all required fields!",
            acceptText: "Close",
          });
          return false;
        }
      }
      return true;
    },

    async submitAllForms() {
      const lastFormIndex = this.forms.length - 1;

      if (!this.validateProperties(this.forms[lastFormIndex].properties)) {
        return false;
      }

      if (!this.forms[lastFormIndex].is_tp_signed_off) {
        await this.createOrUpdateForm(lastFormIndex);
      }

      this.open = false;
      return true;
    },

    async nextStep(sample, index) {
      // if (this.isFormDisabled && this.tastePanelStatus !== "Completed") {
      //   this.$vs.dialog({
      //     color: "warning",
      //     title: "Warning",
      //     text: "Please Start The Taste Panel First!",
      //     acceptText: "Close",
      //   });
      //   return false;
      // }

      if (!this.validateProperties(this.forms[index].properties)) {
        return false;
      }

      if (index !== this.forms.length - 1) {
        if (!sample.is_tp_signed_off) {
          await this.createOrUpdateForm(index);
        }
      }

      return true;
    },

    async createOrUpdateForm(index) {
      try {
        this.$vs.loading();

        const currentForm = this.forms[index];

        const payload = {
          id: currentForm.id,
          type: currentForm.type,
          updated: currentForm.updated,
          status: currentForm.status,
          group_id: this.tastePanelId,
          properties: currentForm.properties,

          notes: currentForm.notes,
          file_paths: currentForm.file_paths,
        };
        if (currentForm.updated) {
          await TriangleTestsRepository.updateQualityControlTestings(
            currentForm.form_id,
            payload
          );
        } else {
          await TriangleTestsRepository.createQualityControlTestings(payload);
        }
      } catch (e) {
        this.convertAndNotifyError(e);
      } finally {
        this.$vs.loading.close();
      }
    },

    getBatchType(typeString) {
      var typeMap = {
        "Modules\\TenentCore\\Entities\\Staff\\Manufacture\\WorkOrder":
          "Work Order",
        "Modules\\TenentCore\\Entities\\Staff\\Manufacture\\RawMaterialStockInventory":
          "Raw Material Inventory",
      };

      return typeMap[typeString] || "Work Order";
    },
  },
};
</script>

<style scoped>
.taste-panel-create-popup >>> .vs-popup {
  min-width: 80% !important;
}
</style>
